import { render, staticRenderFns } from "./CustomerType.vue?vue&type=template&id=15015fe8&scoped=true&"
import script from "./CustomerType.vue?vue&type=script&lang=js&"
export * from "./CustomerType.vue?vue&type=script&lang=js&"
import style0 from "./CustomerType.vue?vue&type=style&index=0&id=15015fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15015fe8",
  null
  
)

export default component.exports